import React, { useCallback, useState } from 'react';
import { PresentationBar } from './components/PresentationBar';
import { TeaserSnak } from './components/teaser/TeaserSnak';
import { ConceptModal } from './components/concept/ConceptModal';
import { IntroStatement } from './components/IntroStatement';
type AppProps = {
  /** Open the concept window on load. */
  conceptOpenOnLoad?: boolean;
};
export function App({
  conceptOpenOnLoad = false
}: AppProps) {
  const [conceptOpen, setConceptOpen] = useState(conceptOpenOnLoad);
  const closeConcept = useCallback(() => setConceptOpen(false), []);
  const openConcept = useCallback(() => setConceptOpen(true), []);
  return <div className="flex min-h-screen w-full flex-col bg-paper" data-id="element-0" data-mp="31ctetq51dy84">
      <PresentationBar onOpenConcept={openConcept} data-id="element-1" data-mp="2wj8ehrfz0s5r" />
      <main className="flex flex-1 flex-col items-center md:justify-center md:py-8 lg:flex-row lg:items-center lg:gap-16 lg:px-10 xl:gap-24" data-id="element-2" data-mp="28ufmg62gz4gf">
        <div className="order-2 w-full px-6 py-12 md:max-w-[440px] md:px-0 lg:order-1 lg:py-0" data-id="element-3" data-mp="23ujk0b9f7l2z">
          <IntroStatement onOpenConcept={openConcept} data-id="element-4" data-mp="3ij652c0mxp8x" />
        </div>
        <div className="order-1 flex w-full flex-1 flex-col items-center md:block md:w-[390px] md:flex-none lg:order-2" data-id="element-5" data-mp="3ml14tc2x3ukl">
          <div className="flex min-h-[640px] w-full flex-1 flex-col overflow-hidden bg-white md:h-[800px] md:max-h-[calc(100vh-130px)] md:min-h-[700px] md:rounded-[44px] md:border-[10px] md:border-ink md:shadow-[0_40px_80px_-30px_rgba(14,27,51,0.45)]" data-id="element-6" data-mp="3rdaq2et386gj">
            <TeaserSnak data-id="element-7" data-mp="2znfyebhrc4op" />
          </div>
          <p className="mt-4 hidden text-center font-mono text-[10px] tracking-[0.2em] text-graphite/70 md:block" data-id="element-8" data-mp="33nq6btp41567">
            REKOVELLE TEASER SNAK · ~40 SECONDS
          </p>
        </div>
      </main>
      <ConceptModal open={conceptOpen} onClose={closeConcept} data-id="element-9" data-mp="3dlw5w4ng1z7w" />
    </div>;
}